import React from 'react';
import { Chip } from '@mui/material';
import { resolveStatusToken } from '../../../constants/statusTokens';

const StatusChip = ({ status, category = 'default', label, color, ...chipProps }) => {
  const token = resolveStatusToken(status, category);
  const chipLabel = label ?? token?.label ?? status;
  const chipColor = color ?? token?.color ?? 'default';

  return (
    <Chip
      label={chipLabel}
      color={chipColor}
      size="small"
      sx={{
        textTransform: 'capitalize',
        borderRadius: 999,
        fontWeight: 600,
        ...(chipColor === 'default'
          ? { bgcolor: 'rgba(122,59,193,0.08)', color: 'primary.main' }
          : {}),
      }}
      {...chipProps}
    />
  );
};

export default StatusChip;
